/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeasureDto } from '../../models/measure-dto';

export interface UpdateMeasure$Params {

/**
 * The customer id
 */
  customerId: number;

/**
 * The measure id
 */
  measureId: number;
      body: MeasureDto
}

export function updateMeasure(http: HttpClient, rootUrl: string, params: UpdateMeasure$Params, context?: HttpContext): Observable<StrictHttpResponse<MeasureDto>> {
  const rb = new RequestBuilder(rootUrl, updateMeasure.PATH, 'put');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('measureId', params.measureId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeasureDto>;
    })
  );
}

updateMeasure.PATH = '/customers/{customerId}/measures/{measureId}';
